import { notification } from 'antd';
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'isDisplayToast';

const getInitial = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === null ? true : JSON.parse(raw);
  } catch (e) {
    console.log("êore : ",e);
    return true;
  }
};

const useInteractiveNotifications = () => {
  const [isDisplayToast, setIsDisplayToast] = useState(getInitial);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isDisplayToast));
    } catch (e) {
    }
  }, [isDisplayToast]);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key !== STORAGE_KEY) return;
      try {
        const newVal = e.newValue === null ? true : JSON.parse(e.newValue);
        setIsDisplayToast(newVal);
      } catch (err) {
      }
    };
    const handleCustom = (e) => {
      try {
        const newVal = e?.detail === undefined ? true : e.detail;
        setIsDisplayToast(newVal);
      } catch (err) {
        // ignore
      }
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('isDisplayToastChanged', handleCustom);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('isDisplayToastChanged', handleCustom);
    };
  }, []);

  const showNotification = (message, type = 'info') => {
    const key = `notification-${Date.now()}`;
    // Read persisted value directly to avoid stale closures or multiple hook instances
    let enabled = true;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      enabled = raw === null ? true : JSON.parse(raw);
    } catch (e) {
      enabled = true;
    }

    if (enabled) {
      notification[type]({
        message: '',
        description: message,
        key,
        duration: 15,
      });
    }
  };

  return { showNotification, isDisplayToast, setIsDisplayToast };
};

export default useInteractiveNotifications;
